import { FC, useEffect, useState } from "react";
import Page, { PageBody, PageHead } from "../../ui/page/page";
import { setRequest } from "../../API";
import Table, { Table_LoadMask } from "../../ui/table/table";
import Tile from "../../components/tile/tile";
import Paginator from "../../components/paginator/paginator";
import Status from "../../components/status/status";
import Form, { FormBody, FormCol, FormRow } from "../../ui/form/form";
import Input from "../../ui/input/input";
import Button from "../../ui/button/button";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import SubscriptionsStore, { ISubscriptionSortField } from "../../store/subscriptionsStore";

interface Props {

}

const headSortMap: Record<number, ISubscriptionSortField> = {
    0: 'id',
    2: 'expire',
    6: 'count',
    7: 'status',
}

const Subscriptions_List_Page: FC<Props> = observer((props: Props) => {
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState<boolean>(false)

    useEffect(() => {
        SubscriptionsStore.setPaginationLimit(20)
    }, [])

    useEffect(() => {
        load()
    }, [SubscriptionsStore.pagination.page, SubscriptionsStore.sort.field, SubscriptionsStore.sort.order])

    const load = () => {
        setLoaded(false)
        setRequest({
            type: 'GET',
            url: `/subscriptions/?${SubscriptionsStore.getListUrl()}`,
            success: (payload) => {
                setLoaded(true)
                SubscriptionsStore.setItems(payload.data)
                SubscriptionsStore.setFilterOptions(payload.filter)
                SubscriptionsStore.setPagination(payload.pagination)
            },
            error: (err) => {
                SubscriptionsStore.setItems([])
                setLoaded(true)
            }
        })
    }

    // смена страницы сама вызывает load через useEffect
    const reload = () => {
        if (SubscriptionsStore.pagination.page === 1) {
            load()
        } else {
            SubscriptionsStore.goToPage(1)
        }
    }

    const applyFilter = () => {
        reload()
    }

    const resetFilter = () => {
        SubscriptionsStore.resetFilter()
        reload()
    }

    const onHeadClick = (index: number) => {
        let field = headSortMap[index]
        if (!field) return
        SubscriptionsStore.setSort(field)
        SubscriptionsStore.goToPage(1)
    }

    const onRowClick = (index: number) => {
        let item = SubscriptionsStore.items[index]
        if (item) navigate(`/subscriptions/${item.id}`)
    }

    const headTitle = (text: string, field?: ISubscriptionSortField) => {
        if (!field || SubscriptionsStore.sort.field !== field) return text
        let icon = SubscriptionsStore.sort.order === 'asc' ? 'chevron-up' : 'chevron-down'
        return `${text} <div class="icon icon-${icon}"></div>`
    }

    return (
        <Page>
            <PageHead title={"Абонементы"} />
            <PageBody>
                <Form asModule={false} className="__searchForm">
                    <FormBody>
                        <FormRow>
                            <FormCol>
                                <Input
                                    type="text"
                                    label="ФИО"
                                    value={SubscriptionsStore.filter.name}
                                    onChange={value => SubscriptionsStore.setFilter('name', value)}
                                />
                            </FormCol>
                            <FormCol>
                                <Input
                                    type="text"
                                    label="E-mail"
                                    value={SubscriptionsStore.filter.email}
                                    onChange={value => SubscriptionsStore.setFilter('email', value)}
                                />
                            </FormCol>
                            <FormCol>
                                <Input
                                    type="text"
                                    label="Телефон"
                                    value={SubscriptionsStore.filter.phone}
                                    onChange={value => SubscriptionsStore.setFilter('phone', value)}
                                />
                            </FormCol>
                            <FormCol>
                                <Input
                                    type="select"
                                    readOnly
                                    label="Статус"
                                    value={SubscriptionsStore.filter.status ?? undefined}
                                    options={SubscriptionsStore.statuses}
                                    onChange={value => SubscriptionsStore.setFilter('status', value)}
                                />
                            </FormCol>
                            <FormCol asRow>
                                <Button type="primary" icon="search" onClick={applyFilter}>Найти</Button>
                                <Button type="secondary" icon="rotate-ccw" onClick={resetFilter}>Сбросить</Button>
                            </FormCol>
                        </FormRow>
                    </FormBody>
                </Form>
                <Tile
                    loaded={loaded}
                    loadMask={<Table_LoadMask />}
                >
                    <Table
                        onHeadClick={onHeadClick}
                        onRowClick={onRowClick}
                        thead={[
                            {
                                width: '6%',
                                title: headTitle('ID', 'id'),
                            },
                            {
                                width: '12%',
                                title: headTitle('Дата окончания', 'expire'),
                            },
                            {
                                width: '26%',
                                title: 'ФИО',
                            },
                            {
                                width: '22%',
                                title: 'E-mail',
                            },
                            {
                                width: '12%',
                                title: 'Телефон',
                            },
                            {
                                width: '10%',
                                title: headTitle('Количество', 'count'),
                            },
                            {
                                width: '12%',
                                title: headTitle('Статус', 'status'),
                            },
                        ]}
                        tbody={SubscriptionsStore.items.map(item => [
                            item.id,
                            item.expire_formatted,
                            `${item.customer.lastName} ${item.customer.name}`,
                            item.customer.email,
                            item.customer.phone,
                            item.count,
                            <Status {...item.status} />,
                        ])}
                    />
                </Tile>
                <Paginator {...SubscriptionsStore.pagination} goToPage={p => SubscriptionsStore.goToPage(p)} />
            </PageBody>
        </Page>
    )
})

export default Subscriptions_List_Page
